import React from 'react';
import { useParams } from 'react-router-dom';

import { LeaderboardConfig, useGetLeaderboardConfigAggregateQuery } from 'api';
import { Loaders } from 'components';
import { useNotify } from 'hooks';

import LeaderboardsEdit from './LeaderboardsEdit';

const LeaderboardConfigLoader = () => {
  const { config_id } = useParams<{ config_id: string }>();
  const notify = useNotify();

  const { data, isLoading } = useGetLeaderboardConfigAggregateQuery(
    { id: config_id },
    { onError: notify.queryError }
  );

  if (isLoading) {
    return <Loaders.Standard />;
  }

  return <LeaderboardsEdit config={data?.getLeaderboardConfigAggregate as LeaderboardConfig} />;
};

export default LeaderboardConfigLoader;
